import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";
import Navbar from "../components/Nav";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast"; // ✅ استدعاء react-hot-toast

const Cart = () => {
  const { cartItems, removeFromCart, updateQuantity, clearCart } = useContext(CartContext);
  const navigate = useNavigate();

  const total = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const styles = {
    container: { padding: "100px 20px", maxWidth: "1000px", margin: "0 auto", fontFamily: "Inter, system-ui, sans-serif" },
    title: { fontSize: "36px", fontWeight: "700", color: "#5b3a29", textAlign: "center", marginBottom: "40px" },
    empty: { textAlign: "center", color: "#8a8f3a", fontSize: "18px", marginTop: "40px" },
    cartItem: { display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #ddd", padding: "20px 0" },
    itemInfo: { display: "flex", alignItems: "center", gap: "20px" },
    img: { width: "100px", height: "100px", borderRadius: "8px", objectFit: "cover" },
    name: { fontSize: "18px", color: "#5b3a29", fontWeight: "600" },
    price: { color: "#8a8f3a", fontWeight: "700" },
    quantityBox: { display: "flex", alignItems: "center", gap: "8px" },
    btn: { background: "#5b3a29", color: "#fff", border: "none", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", fontSize: "16px" },
    total: { textAlign: "right", marginTop: "40px", fontSize: "22px", fontWeight: "700", color: "#5b3a29" },
    checkoutBtn: { display: "block", margin: "30px auto 0", background: "#5b3a29", color: "#fff", padding: "12px 30px", border: "none", borderRadius: "8px", fontSize: "18px", cursor: "pointer", transition: "background 0.3s ease" },
    clearBtn: { display: "block", margin: "10px auto 0", background: "#8a8f3a", color: "#fff", padding: "10px 20px", border: "none", borderRadius: "8px", fontSize: "16px", cursor: "pointer", transition: "background 0.3s ease" },
  };

  const handleRemove = (id, name) => {
    removeFromCart(id);
    toast(`${name} تم حذفه من السلة 🗑️`, { icon: "🗑️" });
  };

  const handleClearCart = () => {
    clearCart();
    toast("تم مسح جميع المنتجات من السلة 🧹", { icon: "🧹" });
  };

  return (
    <>
      <Navbar />
      <Toaster position="top-right" reverseOrder={false} /> {/* ✅ إضافة Toaster */}
      <div style={styles.container}>
        <h1 style={styles.title}>🛍️ Your Cart</h1>

        {cartItems.length === 0 ? (
          <p style={styles.empty}>Your cart is empty 🛒</p>
        ) : (
          <>
            {cartItems.map((item) => (
              <div key={item.id} style={styles.cartItem}>
                <div style={styles.itemInfo}>
                  <img src={item.image} alt={item.name} style={styles.img} />
                  <div>
                    <p style={styles.name}>{item.name}</p>
                    <p style={styles.price}>{item.price} EGP</p>
                  </div>
                </div>

                <div style={styles.quantityBox}>
                  <button
                    style={styles.btn}
                    onClick={() => updateQuantity(item.id, Math.max(item.quantity - 1, 1))}
                  >
                    -
                  </button>
                  <span>{item.quantity}</span>
                  <button
                    style={styles.btn}
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                  >
                    +
                  </button>
                  <button
                    style={{ ...styles.btn, background: "#b93c3c" }}
                    onClick={() => handleRemove(item.id, item.name)} // ✅ إشعار عند الحذف
                  >
                    🗑
                  </button>
                </div>
              </div>
            ))}

            <p style={styles.total}>Total: {total.toLocaleString()} EGP</p>

            <button
              style={styles.checkoutBtn}
              onClick={() => navigate("/checkout")}
            >
              Proceed to Checkout
            </button>
            <button style={styles.clearBtn} onClick={handleClearCart}> {/* ✅ إشعار عند مسح السلة */}
              Clear Cart
            </button>

            <style>{`button:hover { opacity: 0.9; }`}</style>
          </>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Cart;
